/**
 * Theme head init: coverage/quantity sync. Runs after jQuery (deferred).
 */
(function () {
    if (typeof jQuery === 'undefined') return;
    jQuery(document).ready(function () {
        jQuery(document).on('focusout', '.coverage', function () {
            var proId = jQuery(this).attr('data-id');
            var quan = parseInt(jQuery(this).val(), 10);
            if (typeof quan === 'undefined' || quan !== quan || quan <= 0) quan = 1;
            var sqftPer = parseFloat(jQuery('.sqftPerCarton[data-id=' + proId + ']').val());
            var total = Math.ceil(quan / sqftPer);
            var newQuan = parseFloat(total * sqftPer).toFixed(2);
            jQuery(this).val(newQuan);
            jQuery('.quantity[data-id=' + proId + ']').val(total).change();
        });
        jQuery(document).on('focusout', '.quantity', function () {
            var proId = jQuery(this).attr('data-id');
            var total = parseInt(jQuery(this).val(), 10);
            if (typeof total === 'undefined' || total !== total || total <= 0) total = 1;
            var sqftPer = parseFloat(jQuery('.sqftPerCarton[data-id=' + proId + ']').val());
            var newQuan = parseFloat(total * sqftPer).toFixed(2);
            jQuery('.coverage[data-id=' + proId + ']').val(newQuan).change();
            jQuery(this).val(total);
        });
    });
})();
